import React from "react";
import UserList from "../../Components/UserList";

const Donors = () => {
  return <UserList role="donor" roleLabel="Donors" />;
};

export default Donors;
